import { Box, Flex, HStack, Link, Text, VStack } from '@chakra-ui/react';
import { AiOutlineQuestionCircle } from 'react-icons/ai';
import React from 'react';

export default function HelpNavigationCard() {
  return (
    <Link href={'https://ai-copywriter.notion.site/Catchy-8fa43ce884f7474799765728675d7025'} target={'_blank'}>
      <Box
        borderWidth="1px"
        borderRadius="lg"
        bg={'white'}
        boxShadow={'2xl'}
        py={4}
        px={2}
        cursor={'pointer'}
        _hover={{ borderColor: '#7e96ff' }}
      >
        <Flex alignItems={'center'} justifyContent={'start'} mb={3}>
          <VStack>
            <HStack>
              <AiOutlineQuestionCircle fontSize={'20px'} color="navy" />
              <Text fontWeight={'bold'}>ヘルプ</Text>
            </HStack>
            <Text pl={2} mt={2} fontSize={'sm'} color={'gray.600'}>
              Catchyの使い方の解説、さらに活用するためのコンテンツを用意しています。
            </Text>
          </VStack>
        </Flex>
      </Box>
    </Link>
  );
}
